[
  {
    "id": "ho-ho-ho-heave-ho",
    "title": "Ho Ho Ho Heave Ho",
    "artist": "Ben",
    "src": "./audio/music/Ho Ho Ho Heave Ho.mp3",
    "license": "original"
  },
  {
    "id": "jingle-bell-do-si-do",
    "title": "Jingle Bell Do-Si-Do",
    "artist": "Ben",
    "src": "./audio/music/Jingle Bell Do-Si-Do.mp3",
    "license": "original"
  },
  {
    "id": "steak-and-titties",
    "title": "Steak and Titties",
    "artist": "Ben",
    "src": "./audio/music/Steak and Titties.mp3",
    "license": "original"
  }
]
